import { css, styled } from "@mui/material";
import { ROW_ALIGN_CENTER__SPACE_B } from "../../../styles/global-styles";
import { breakpoints } from "../../../styles/media-queries";

export const FooterNavigationStyled = styled("nav")`
  ${ROW_ALIGN_CENTER__SPACE_B};
  /* Content-sized rather than a hard-coded 649px, for the same reason as the
     header nav: the row has to hold however many items the list has. */
  gap: 32px;
  flex: 0 1 auto;
  min-width: 0;
  @media (min-width: ${breakpoints.xxl}px) {
    gap: 56px;
  }
  @media (min-width: ${breakpoints.xxs}px) and (max-width: ${breakpoints.lg}px) {
    flex-direction: column;
    width: unset;
  }
  @media (max-width: ${breakpoints.xxs}px) {
    flex-direction: column;
    width: unset;
  }
  transition: opacity 1s;
  * {
    ${(props) =>
      props.hoveredItem
        ? css`
            transition: opacity 0.6s;
            opacity: 0.5;
          `
        : css`
            transition: opacity 0.6s;
            opacity: 1;
          `}
  }

  & .nav-items {
    color: var(--River-bed);
    text-transform: uppercase;
    font-size: 11px;
    line-height: 130%;
    display: flex;
    align-items: center;
    letter-spacing: 0.15em;
    white-space: nowrap;
    margin: -10px -12px;
    padding: 10px 12px;
    :hover {
      opacity: 1;
      cursor: pointer;
    }
  }
`;
